export const BETA_THEME_STORAGE_KEY = "urban-portal-beta-theme-v2";
export const BETA_THEME_CHANGE_EVENT = "urban-portal-beta-theme-change";

export function clearBetaThemeBootstrap() {
    if (typeof document === "undefined") return;
    document.documentElement.classList.remove(
        "beta-theme-bootstrap",
        "beta-theme-bootstrap--dark"
    );
}

const VALID_BETA_THEME_PREFERENCES = new Set(["system", "light", "dark"]);

export function getBetaThemePreference(storage = typeof window !== "undefined" ? window.localStorage : null) {
    try {
        const value = storage?.getItem(BETA_THEME_STORAGE_KEY);
        return VALID_BETA_THEME_PREFERENCES.has(value) ? value : "system";
    } catch {
        return "system";
    }
}

export function getBetaEffectiveTheme(preference) {
    if (preference === "dark") return "dark";
    if (preference === "system" && typeof window !== "undefined" && typeof window.matchMedia === "function") {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return "light";
}

export function persistBetaThemePreference(preference, storage = typeof window !== "undefined" ? window.localStorage : null) {
    const value = VALID_BETA_THEME_PREFERENCES.has(preference) ? preference : "system";
    try {
        storage?.setItem(BETA_THEME_STORAGE_KEY, value);
    } catch {
        // Ignore storage failures; the in-memory theme still applies.
    }
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
        window.dispatchEvent(new CustomEvent(BETA_THEME_CHANGE_EVENT, {
            detail: { preference: value },
        }));
    }
    return value;
}
